import { render, staticRenderFns } from "./proxyGoodsCon.vue?vue&type=template&id=8cbb3548&scoped=true"
import script from "./proxyGoodsCon.vue?vue&type=script&lang=js"
export * from "./proxyGoodsCon.vue?vue&type=script&lang=js"
import style0 from "./proxyGoodsCon.vue?vue&type=style&index=0&id=8cbb3548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbb3548",
  null
  
)

export default component.exports